<template>
    <div>
      <input
        v-if="options.type && options.type == 'currency'"
        v-model="cptCurrency"
        v-bind:placeholder="placeholder"
        v-bind:disabled="disabled"
        v-bind:backgroundColor="backgroundColor"
        v-bind:class="classC"
        :key="forceRenderKey"
        @keydown="keyCurrencyDown($event, usedCurrency)"
      />
      <input
        v-else
        v-model.lazy="cmpValue"
        v-bind:placeholder="placeholder"
        v-bind:disabled="disabled"
        v-bind:backgroundColor="backgroundColor"
        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
        v-bind:class="classC"
      />
    </div>
  </template>
  
  <script>
  export default {
    model: { prop: "value", event: "input" },
    props: {
        classC: {
            type: String,
            default: '',
        },
        value: {
            // type: String,
            type: [String, Number],
            default: "0",
        },
        placeholder: {
            type: String,
            default: undefined,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        backgroundColor: {
            type: String,
            default: "white",
        },
        valueWhenIsEmpty: {
            type: String,
            default: "", // "0" or "" or null
        },
        options: {
            type: Object,
            default: function () {
            return {
                type: null,
                locale: "pt-BR",
                prefix: "",
                suffix: "",
                length: 11,
                precision: 2,
            };
            },
        },
    },
    data() {
      return {
        timeout: null,
        forceRenderKey: 0
      }
    },
    computed: {
      cmpValue: {
        get: function () {
          return this.value !== null && this.value !== ""
            ? this.humanFormat(this.value.toString())
            : this.valueWhenIsEmpty;
        },
        set: function (newValue) {
          this.$emit("input", this.machineFormat(newValue));
        },
      },
      cptCurrency: {
        get: function () {
          return this.value !== null && this.value !== ""
            ? this.convertDecimalViaLocal(this.value.toString())
            : this.valueWhenIsEmpty;
        },
        set: function (newValue) {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            const value = this.setCurrency(newValue);
            this.$emit("input", value);
            if (this.value == value) {
              this.forceRenderKey++;
            }
          }, this.timeOutChange(newValue));
        },
      }
    },
    methods: {
      humanFormat: function (number) {
        if (isNaN(number)) {
          number = "";
        } else {
          number = new Intl.NumberFormat(this.$i18n.locale, {
            style: 'decimal',
            maximumFractionDigits: this.options.precision,
            minimumFractionDigits: this.options.precision,
          }).format(number);
        }
        return number;
      },
      machineFormat(number) {
        if (number) {
          number = this.cleanNumber(number);
          number = number.padStart(parseInt(this.options.precision) + 1, "0");
          number =
            number.substring(0, number.length - parseInt(this.options.precision)) +
            "." +
            number.substring(
              number.length - parseInt(this.options.precision),
              number.length
            );
          if (isNaN(number)) {
            number = this.valueWhenIsEmpty;
          }
        } else {
          number = this.valueWhenIsEmpty;
        }
        if (this.options.precision === 0) {
          number = this.cleanNumber(number);
        }
        return number;
      },
      keyPress($event) {
        let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 45) {
          $event.preventDefault();
        }
        if (this.targetLength()) {
          $event.preventDefault();
        }
      },
      cleanNumber: function (value) {
        let result = "";
        if (value) {
          let flag = false;
          let arrayValue = value.toString().split("");
          for (var i = 0; i < arrayValue.length; i++) {
            if (this.isInteger(arrayValue[i])) {
              if (!flag) {
                if (arrayValue[i] !== "0") {
                  result = result + arrayValue[i];
                  flag = true;
                }
              } else {
                result = result + arrayValue[i];
              }
            } else if (i === 0 && arrayValue[i] === "-") {
              result = result + arrayValue[i];
            }
          }
        }
        return result;
      },
      isInteger(value) {
        let result = false;
        if (Number.isInteger(parseInt(value))) {
          result = true;
        }
        return result;
      },
      targetLength() {
        if (Number(this.cleanNumber(this.value).length) >= Number(this.options.length)) {
          return true;
        } else {
          return false;
        }
      },
    },
  };
  </script>
  